import './listing.css'

function Listing({lists}) {
    return (
        <div className='list--item '>
                  <h4 className='list--title'>{lists.title}</h4>
            <div className='ul--list'>
                <img src={lists.img} alt='' className='list--Image'/>
                <div className='list'><p><b>Cost </b> {lists.cost}</p></div>
                <div className='list'><p><b>Locations:</b> {lists.location} </p></div>
                <div  className='list--btn' ><button>Connect <b>{lists.phone}</b></button></div>
            </div>
        </div>
    )
}

export default Listing
